module.exports = __webpack_public_path__ + "assets/logo_onward.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_onward.png
 ** module id = 143
 ** module chunks = 1
 **/